import QRCode from "react-qr-code";
import styled from "@emotion/styled";

export const QRCodeComponent = styled(QRCode)`
  border: solid 0.75rem #fff;
  border-radius: 0.75rem;
`;
